import { useNavigate } from 'react-router-dom';
import { Globe } from 'lucide-react';
import PageHeader from '../components/PageHeader';
import Button from '../components/ui/Button';

/**
 * Placeholder shown when a native-app user reaches a billing / subscription
 * management route. Billing flows live on the web only to keep us inside the
 * App Store / Play Store B2B payments exemption — we do not link out to a
 * purchase page from inside the app.
 */
function WebOnlyNotice() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-neutral-50">
      <PageHeader
        title="Managed by your organisation"
        subtitle="Subscription and billing settings aren't available in the mobile app"
        icon={<Globe className="h-6 w-6 text-white" />}
      />

      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="bg-white border border-neutral-200 rounded-xl p-6 shadow-sm">
          <p className="text-neutral-700 mb-6">
            Module subscriptions, seats and invoices are handled by your organisation's
            administrator. Please contact them if you need a change to your access.
          </p>
          <Button variant="outline" onClick={() => navigate('/dashboard')}>
            Back to dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}

export default WebOnlyNotice;
